$(document).ready(function() {
    function toggleLeftPanel() {
        $('.left-panel').toggleClass('open');

        if ($('.left-panel').hasClass('open')) {
            if (!$('.left-panel').prev().hasClass('left-panel-close-backing')) {
                $('<div class="left-panel-close-backing"></div>').insertBefore('.left-panel');
            }
        } else {
            $('.left-panel-close-backing').remove();
        }
    }

    $('.js-trigger-filters').on('click', function() {
        toggleLeftPanel();
    });

    $('.mobile-filters-close').not('.algolia-close').on('click', function() {
        toggleLeftPanel();
    });

    $(document).on('click', '.left-panel-close-backing', function() {
        toggleLeftPanel();
    });
});
